import React, { useEffect, useState } from "react";
import { useForm } from "@formspree/react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Typography } from "@mui/material";

const ContactUs = () => {
  const [state, handleSubmit] = useForm("mwkdgnwq");
  // State hooks for each form field
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [showThankYou, setThankYou] = useState(false);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
  };

  const formStyle = {
    width: "100%",
    maxWidth: "500px",
  };

  // Handle form submission with Formspree
  const onSubmit = async (e) => {
    e.preventDefault();
    await handleSubmit({
      name,
      email,
      subject,
      message,
    });
  };

  useEffect(() => {
    if (state.succeeded) {
      setThankYou(true);
      setTimeout(() => {
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
        setThankYou(false);
      }, 5000);
    }
  }, [state.succeeded]);

  if (showThankYou) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        paddingY={5}
      >
        <Typography component="h2" align="center" variant="h1" color="#1F6348">
          Thank
        </Typography>
        <Typography component="h2" align="center" variant="h1" color="#5B6B7C">
          You!
        </Typography>
      </Box>
    );
  }

  return (
    <Box id="contactUs" style={containerStyle}>
      <Typography
        component="h2"
        align="center"
        variant="h4"
        color="text.primary"
        mb={2}
      >
        Contact Us
      </Typography>
      <form style={formStyle} onSubmit={onSubmit}>
        <TextField
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ marginBottom: 1.5 }}
          label="Name"
          variant="outlined"
          fullWidth
          required
        />
        <TextField
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ marginBottom: 1.5 }}
          label="Email"
          variant="outlined"
          fullWidth
          required
          type="email"
        />
        <TextField
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          sx={{ marginBottom: 1.5 }}
          label="Subject"
          variant="outlined"
          fullWidth
          required
        />
        <TextField
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          sx={{ marginBottom: 1.5 }}
          label="Message"
          variant="outlined"
          multiline
          fullWidth
          required
          rows={4}
        />
        <Button
          variant="contained"
          type="submit"
          fullWidth
          disabled={state?.submitting}
          startIcon={
            state?.submitting && <CircularProgress size={24} color="inherit" />
          }
        >
          {state.submitting ? "Sending..." : "Send Message"}
        </Button>
      </form>
    </Box>
  );
};

export default ContactUs;
